"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.following = exports.canFollow = exports.unfollow = exports.follow = exports.doUnfollow = exports.doFollow = void 0;

var _fetch = babelHelpers.interopRequireDefault(require("fetch"));

var _userProfile = require("user-profile");

var _noty = require("noty");

var _decorators = require("decorators");

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var Follow =
/*#__PURE__*/
function () {
  function Follow() {
    babelHelpers.classCallCheck(this, Follow);
  }

  babelHelpers.createClass(Follow, null, [{
    key: "doFollow",
    value: function doFollow(id, name) {
      (0, _fetch.default)("data/following/add", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: id
        })
      }).then(function () {
        (0, _userProfile.userProfileUpdated)();
        (0, _noty.showNotificationText)('You are now following ' + name + '.');
      });
    }
  }, {
    key: "doUnfollow",
    value: function doUnfollow(id, name) {
      (0, _fetch.default)("data/following/remove", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: id
        })
      }).then(function () {
        (0, _userProfile.userProfileUpdated)();
        (0, _noty.showNotificationText)('You are no longer following ' + name + '.');
      });
    }
  }]);
  return Follow;
}();

var doFollow = Follow.doFollow,
    doUnfollow = Follow.doUnfollow,
    follow = Follow.follow,
    unfollow = Follow.unfollow,
    canFollow = Follow.canFollow,
    following = Follow.following;
exports.following = following;
exports.canFollow = canFollow;
exports.unfollow = unfollow;
exports.follow = follow;
exports.doUnfollow = doUnfollow;
exports.doFollow = doFollow;